import LazyStandalonePackageEmbedContainer from "@pathwright/features/src/modules/package/embed/LazyStandalonePackageEmbedContainer"
import { Route, Switch } from "react-router-dom"

export const packageEmbedRoute = {
  path: "/embed/package/",
  component: LazyStandalonePackageEmbedContainer
}

const EmbedsRoute = () => (
  <Switch>
    <Route
      path={packageEmbedRoute.path}
      component={packageEmbedRoute.component}
      exact
    />
  </Switch>
)

EmbedsRoute.path = "/embed/"

export default EmbedsRoute
